import {combineReducers} from "redux";
import { call, put, select, takeLatest, delay } from 'redux-saga/effects';
import {reportsAPI} from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import {START} from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";
import { reportParamsReducer } from "./reportParams/reportParamsReducer";
import { getFormParams, getOrgFormattedData } from "../../../utils/smallHelpers";



export const GRADUATES_HEO_REQUEST = "GRADUATES_HEO_REQUEST";
export const SET_FORM_DATA = "SET_GRADUATES_HEO_FORM_DATA";
export const SET_REPORT_PARAMS = "SET_GRADUATES_HEO_YEAR";

export const graduatesHEOReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
    report_params: reportParamsReducer
});

//actions
export const graduatesActions = createActions('graduatesHeo', GRADUATES_HEO_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload});
export const setReportParams = payload => ({ type: SET_REPORT_PARAMS, payload});

// SAGAS
export function* graduatesHEOWatcher() {
    yield takeLatest(`${GRADUATES_HEO_REQUEST}${START}`, graduatesHEOWorker)
}

function* graduatesHEOWorker() {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.graduatesHEO.form)
        const payload = getFormParams(form)
        const params = {...auth, ...payload}
        const response = yield call(reportsAPI.graduatesHEO, params);
        const data = getOrgFormattedData(response.data.Answer.Data)
        yield put(graduatesActions.graduatesHeoRequestSuccess(data));
        yield put(setReportParams(form))
    } catch(error) {
        yield put(graduatesActions.graduatesHeoRequestError(error));
    }
}